import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import api from "../../../api";
import { useInvoicesHeader } from "./Components/InvoicesHeader/useInvoicesHeader";
import { getUTCDate } from "../../../helperFunctions";
import { showToast } from "../../../Components/Toast";
import {
  validateAccountCodeValue,
  validateAccountCode,
} from "../../../formsValidation";

export let useInvoices = create(
  immer((set, get) => ({
    section: "all Invoices",

    formMode: undefined,
    processingInvoice: false,

    //Pagination
    invoicesArrayLength: 0,
    invoicesData: [],
    invoices: [],
    //Sort
    sortColumn: "createdAt",
    sortSettings: { ["createdAt"]: "desc" }, //desc

    form: {
      document_type: "Invoice",
      invoice_filename: "",
      invoice_date: new Date(),
      invoice_number: "",
      invoice_from: "",
      invoice_to: "",
      invoice_total: "",
      invoice_subtotal: "0.00",
      invoice_discount: "0.00",
      invoice_vat: "0.00",
      invoice_tax: "0.00",
      // invoice_other_cost: "0.00",
      invoice_other_charges: [["Other", "0.00"]],
      invoice_order_amount: "",
      invoice_currency: "",

      invoice_items_title: [
        "No",
        "Description",
        "Quantity",
        "Unit",
        "Unit Price",
        "Amount",
      ],
      invoice_items: [["", "", "", "", "", ""]],
      invoice_codes: [["", "0.00"]],
      total_by_accounts: "0.00",

      //[{ id: nanoid(), itemId: '', desc: '', qty: '', unit: '', unitPrice: '', amount: '', other: '' }],
      invoice_due_date: undefined,
      invoice_status: "OCR",
      invoice_account: "",
      invoice_bank: "",

      vessel_name: "",
      purchase_order_number: "",
      user_id: undefined,

      department: "",
      type: "",
      workflow_id: undefined,
      notes: "",
    },

    itemsPerPage: 10,
    activePage: 1,

    handleSort: async (data, type) => {
      set({ sortSettings: { [data]: type } });
      await get().getInvoices();
      set({ sortColumn: data });
    },

    invoiceDateHandler: (date) => {
      set((state) => {
        state.form.invoice_date = getUTCDate(date);
      });
    },

    invoiceDueDateHandler: (date) => {
      set((state) => {
        state.form.invoice_due_date = getUTCDate(date);
      });
    },

    accountHandler: (value) => {
      set({ form: { ...get().form, invoice_account: value } });
    },

    userHandler: (value) => {
      set({ form: { ...get().form, user_id: value } });
    },

    departmentHandler: (department) => {
      set((state) => {
        state.form.department = department;
      });
    },

    vesselHandler: (vessel_name) => {
      set((state) => {
        state.form.vessel_name = vessel_name;
      });
    },

    documentTypeHandler: (type) => {
      set((state) => {
        state.form.document_type = type;
      });
    },

    invoiceTypeHandler: (type) => {
      set((state) => {
        state.form.type = type;
      });
    },

    showCreateInvoice: () => {
      get().clear();
      set({ section: "form", formMode: "create" });
    },

    showEditInvoice: async (invoicesId) => {
      //let counts = get().countFormChanges;
      //console.log(counts);
      let form = await api.invoices.getById(invoicesId);
      if (form) set({ form, section: "form", formMode: "edit" });
      //let counts2 = get().countFormChanges;
      //console.log(counts2);
    },

    cancel: async () => {
      set({ section: "all invoices" });
      get().clear();
      await get().getInvoices();
    },

    formHandler: (form) => {
      set({ form });
    },

    countryHandler: (value) => {
      set((state) => {
        state.form.country = value;
      });
    },

    invoiceStatusHandler: (value) => {
      set((state) => {
        state.form.invoice_status = value;
      });
    },

    itemsHandler: (v) => {
      set({ form: { ...get().form, items: v } });
    },

    getInvoices: async () => {
      const { activePage, itemsPerPage, sortSettings } = get();
      const { filter, searchValues } = useInvoicesHeader.getState();

      const options = {
        activePage,
        itemsPerPage,
        ...filter,
        ...searchValues,
        sortSettings,
      };

      let { data, total } = await api.invoices.getAll(options);

      if (!data?.length) {
        set({ invoices: [] });
        set({ invoicesArrayLength: 0 });

        return;
      }
      set({
        invoices: data,
        invoicesArrayLength: total,
      });
    },

    createInvoice: async () => {
      let { form } = get();

      // let error = validateItemsBlock(form.items);
      // if (error) return showToast('e', 'Select part');

      // error = validateItemsBlock_QtyInput(form.items);
      // if (error) return showToast('e', 'Item QTY is empty');

      const { total_by_accounts, vendor_address, ...rest } = form;
      const createPayload = {
        ...rest,
        user_id: rest.user_id === "Unassigned" ? undefined : rest.user_id,
      };

      let response = await api.invoices.create(createPayload);
      if (response === true) {
        //let { getInvoices, cancel } = get();
        set({ form });
        set({ countFormChanges: 1 });
        //await getInvoices();
        //cancel();
      }
    },

    updateInvoice: async () => {
      let { form, message, cancel } = get();

      // let error = validateItemsBlock(form.items);
      // if (error) return showToast('e', 'Select part');

      // error = validateItemsBlock_QtyInput(form.items);
      // if (error) return showToast('e', 'Item QTY is empty');

      let invoiceId = form._id;
      const { vendor_address, total_by_accounts, ...formRest } = form;
      const updatePayload = {
        ...formRest,
        ...(message ? { message } : {}),
        user_id: formRest.user_id === "Unassigned" ? undefined : formRest.user_id,
      };

      let response = await api.invoices.updateById(invoiceId, updatePayload);
      if (response === true) {
        let form = await api.invoices.getById(invoiceId);
        set({ form });
        set({ countFormChanges: 1 });
        //await getInvoices();
        //cancel();
      }
    },

    invoiceBankHandler: async (invoice_bank) => {
      set({ form: { ...get().form, invoice_bank } });
      let { form, updateInvoice } = get();
      let invoiceId = form._id;
      const { vendor_address, total_by_accounts, ...formRest } = form;
      const bankPayload = {
        ...formRest,
        user_id: formRest.user_id === "Unassigned" ? undefined : formRest.user_id,
      };
      let response = await api.invoices.updateById(invoiceId, bankPayload);
      if (response === true) {
        set({ countFormChanges: 1 });
      }
    },

    deleteInvoice: async () => {
      let { form, cancel } = get();

      let invoiceId = form._id;
      let response = await api.invoices.deleteById(invoiceId);
      if (response === true) {
        //await getInvoices();
        cancel();
      }
    },

    updateStatus: async (status) => {
      let { form, cancel } = get();
      let invoiceId = form._id;

      if (status === "For payment" && !form?.invoice_bank)
        return showToast("e", "Please choose a bank for payment first");

      if (status === "Approved") {
        if (!form?.department || form?.department === "Unassigned")
          return showToast("e", "Please select Department");

        if (!form?.user_id || form?.user_id === "Unassigned")
          return showToast("e", "Please select User");

        if (!form?.type || form?.type === "Unassigned")
          return showToast("e", "Please select Type");

        if (!form?.invoice_due_date)
          return showToast("e", "Please select Due Date");

        // if (!form?.invoice_codes || form?.invoice_codes[0][0] == "")
        //   return showToast("e", "Please select Account Code");

        const errorAccountCode = validateAccountCode(form?.invoice_codes);
        if (errorAccountCode)
          return showToast("e", "Please select Account Code");

        const error = validateAccountCodeValue(form?.invoice_codes);
        if (error) return showToast("e", "Please enter Account Code value");
      }

      // if (status == "Approved") {
      //   let responseUpdate = await api.invoices.updateById(invoiceId, form);
      //   if (responseUpdate === true) {
      //     set({ countFormChanges: 0 });
      //   }
      // }

      const response = await await api.invoices.updateStatusById(
        invoiceId,
        status
      );
      if (response === true) {
        cancel();
      }
    },

    message: undefined,

    messageHandler: (v) => {
      set({ message: v });
    },

    setActivePage: (page) => {
      set({ activePage: page });
    },

    attachFile: async (invoice_filename) => {
      set({
        form: {
          ...get().form,
          invoice_filename,
        },
      });
    },

    handleCheckBox: async (invoiceId, number) => {
      const status = "Posted";
      if (!invoiceId) return;
      const response = await await api.invoices.updateStatusById(
        invoiceId,
        status
      );
      if (response === true) {
        //showToast("s", `Invoice #${number} has been set as posted`);
        let { invoices } = get();
        const updatedInvoices = invoices.map((invoice) => {
          if (invoice._id === invoiceId) {
            // Use the newCheckedState to determine the new invoice_posted_date
            return {
              ...invoice,
              invoice_posted_date: new Date().toISOString(),
            };
          }
          return invoice;
        });
        set({ invoices: updatedInvoices });

        return;
      } else {
        return showToast("e", `Error setting Invoice #${number} as posted`);
      }
    },

    deleteAttachedInvoice: async () => {
      set({ form: { ...get().form, invoice_filename: "" } });
    },

    attachInvoices: async (newInvoices) => {
      const { _id: invoicesId } = get().form;

      //const invoices = { invoicesId: invoicesId, invoices: newInvoices };

      const response = await api.purchaseOrder.attachInvoices(invoicesId, {
        invoices: newInvoices,
      });

      if (response === true) {
        let form = await api.purchaseOrder.getById(invoicesId);
        set({ form });
      }
    },

    // deleteAttachedInvoice: async (invoiceId, fileName) => {
    // 	const { _id: invoicesId } = get().form;

    // 	const invoice = { id: invoiceId, fileName: fileName };

    // 	const response = await api.purchaseOrder.deleteInvoice(invoicesId, invoice);

    // 	if (response === true) {
    // 		let form = await api.purchaseOrder.getById(invoicesId);
    // 		set({ form });
    // 	}
    // },

    getAttachedInvoicesData: async () => {
      let attachedInvoices = get().form.attachedInvoices;
      if (attachedInvoices.length > 0) {
        let attachedInvoicesData = await api.file.getFilesByIds(
          attachedInvoices
        );
        set({ invoicesData: attachedInvoicesData });
      } else {
        set({ invoicesData: [] });
      }
    },

    tableLoading: false,
    setTableLoading: (state) => {
      set({ tableLoading: state });
    },

    loading: false,

    countFormChanges: 0,
    formWasChanged: false,

    resetFormChanges: () => {
      set({ countFormChanges: 0 });
    },

    generating: false,
    generatingRL: false,

    clear: () => {
      set({
        section: "all Invoices",
        formMode: undefined,
        invoicesArrayLength: 0,
        invoicesData: [],
        invoices: [],
        form: {
          document_type: "Invoice",
          invoice_filename: "",
          invoice_date: new Date(),
          invoice_number: "",
          invoice_from: "",
          invoice_to: "",
          invoice_total: "0.00",
          invoice_subtotal: "0.00",
          invoice_discount: "0.00",
          invoice_vat: "0.00",
          invoice_tax: "0.00",
          // invoice_other_cost: "0.00",
          invoice_other_charges: [["Other", "0.00"]],
          invoice_order_amount: "",
          invoice_currency: "",
          invoice_items_title: [
            "No",
            "Description",
            "Quantity",
            "Unit",
            "Unit Price",
            "Amount",
          ],
          invoice_items: [["", "", "", "", "", ""]],
          invoice_codes: [["", "0.00"]],
          total_by_accounts: "0.00",

          invoice_due_date: undefined,
          invoice_status: "OCR",
          invoice_account: undefined,
          invoice_bank: "",

          vessel_name: "",
          purchase_order_number: "",
          user_id: undefined,

          department: "",
          type: "",
          workflow_id: undefined,
          notes: "",
        },

        message: undefined,
        loading: false,
        formWasChanged: false,
        countFormChanges: 0,
        ispdfShow: false,
        ispdfFrameShow: false,
        pdfPositionY: undefined,
        selectedPdf: undefined,
        pageNumber: 1,
        numPages: 0,
      });
    },

    ispdfShow: false,

    ispdfFrameShow: false,
    pdfPositionY: undefined,
    numPages: 0,
    pageNumber: 1,
    selectedPdf: undefined,
    handlepdfShow: (url) => {
      set({ ispdfShow: true, selectedPdf: url });
    },

    handlepdfClose: () => {
      set({
        ispdfShow: false,
        selectedPdf: undefined,
        pageNumber: 1,
        numPages: 0,
      });
    },
    handlepdfFrameShow: (e) => {
      const iconPositionY = e.currentTarget.getBoundingClientRect().top;

      set((state) => ({
        ispdfFrameShow: !state.ispdfFrameShow,
        pdfPositionY: iconPositionY,
      }));
    },
    handlepdfFrameClose: () => {
      set({
        ispdfFrameShow: false,
        selectedPdf: undefined,
        pageNumber: 1,
        numPages: 0,
      });
    },
    onDocumentLoadSuccess: (doc) => {
      set({ numPages: doc.numPages });
    },

    goToPrevPage: (doc) => {
      set({ pageNumber: get().pageNumber - 1 <= 1 ? 1 : get().pageNumber - 1 });
    },

    goToNextPage: (doc) => {
      set({
        pageNumber:
          get().pageNumber + 1 >= get().numPages
            ? get().numPages
            : get().pageNumber + 1,
      });
    },

    processInvoice: async () => {
      set({ processingInvoice: true });
      let invoiceFilename = get().form.invoice_filename;
      if (invoiceFilename.length > 0) {
        let invoiceData = await api.invoices.processInvoice(invoiceFilename);
        if (invoiceData) {
          set({
            //formMode: 'edit',
            form: {
              ...get().form,

              invoice_date: invoiceData.invoice_date,
              invoice_due_date: invoiceData.invoice_due_date,
              invoice_number: invoiceData.invoice_number,
              invoice_from: invoiceData.invoice_from,
              invoice_to: invoiceData.invoice_to,
              invoice_total: invoiceData.invoice_total,
              invoice_subtotal: invoiceData.invoice_subtotal,
              invoice_discount: invoiceData.invoice_discount,
              invoice_vat: invoiceData.invoice_vat,
              invoice_tax: invoiceData.invoice_tax,
              invoice_order_amount: invoiceData.invoice_order_amount,
              invoice_currency: invoiceData.invoice_currency,
              invoice_items_title: invoiceData.invoice_items_title,
              invoice_items: invoiceData.invoice_items,
              invoice_other_charges: invoiceData.invoice_other_charges,
              vendor_address: invoiceData.vendor_address,
              vessel_name: invoiceData.vessel_name,
              purchase_order_number: invoiceData.purchase_order_number,
              invoice_status: "OCR",
            },
          });
        }
        set({ processingInvoice: false });
      } else {
        set({ processingInvoice: false });
        return showToast("e", "Invoce URL is empty");
      }
    },
  }))
);
const blobToArrayBuffer = async (blob) => {
  const arrayBuffer = await blob.arrayBuffer();
  return new Uint8Array(arrayBuffer);
};

const unsubscribe = useInvoices.subscribe(
  (newState, prevState) => {
    if (prevState.form !== newState.form && newState.formMode) {
      useInvoices.setState((state) => ({
        countFormChanges: state.countFormChanges + 1,
      }));

      // const changes = Object.keys(newState.form).reduce((acc, key) => {
      //   if (newState.form[key] !== prevState.form[key]) {
      //     acc[key] = { old: prevState.form[key], new: newState.form[key] };
      //   }
      //   return acc;
      // }, {});

      // if (Object.keys(changes).length > 0) {
      //   console.log("Changes:", changes);
      // }
    }
  },
  (state) => state.form // This specifies the property to watch for changes
);
